<template>
  <div class="HomeRecommendSpecialCard">
    <a
      :href="url ? url : path"
      :target="url ? '_blank' : ''"
      :rel="url ? 'noopener' : ''"
      @click="onClick"
    >
      <div class="cardImage">
        <img :src="image" :alt="imageAlt" />
        <PRBadge v-if="showPr" class="pr" />
      </div>
      <div class="cardBody">
        <h3 class="cardTitle">{{ heading }}</h3>
        <p class="cardCategory">{{ category }}</p>
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import PRBadge from '../elements/PRBadge.vue'

export default defineComponent({
  name: 'HomeRecommendSpecialCard',

  components: {
    PRBadge
  },

  props: {
    image: String,
    imageAlt: {
      type: String,
      default: ''
    },
    category: String,
    heading: String,
    url: String,
    path: {
      type: String,
      default: '/'
    },
    showPr: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const router = useRouter()

    const onClick = (e: MouseEvent) => {
      if (props.url) return true
      if (e.ctrlKey || e.metaKey) return true

      e.preventDefault()
      return router.push(props.path)
    }

    return {
      onClick
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.HomeRecommendSpecialCard {
  line-height: 1.78;

  a {
    display: block;
    width: 100%;
  }

  img {
    width: 100%;
  }
}

.cardImage {
  position: relative;
}

.cardTitle {
  margin-top: 10px;
  line-height: 1.3;
  font-size: 1.5rem;
  font-weight: 500;
}

.cardCategory {
  display: inline-block;
  margin-top: 4px;
  font-size: 1rem;
  font-weight: 500;
  background-color: var.$color-accent-back;
  padding: 4px;
  line-height: 1;
}

.pr {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px 11px;
  background-color: rgba(58, 58, 58, 0.8);
  color: #fff;
  font-size: 13px;
  line-height: 13px;

  @include mixins.mediaMax('sm') {
    padding: 4px 8px;
    font-size: 11px;
    line-height: 11px;
  }
}
</style>
